var fifi = {
	"coupon-callout": {
	"coupon-code": "Koodi",
	"coupon-message-with-price": "Kirjoita {{ price }}",
	"coupon-expiry-message": "Vanhenee {{ Date }}.",
	"code-at-checkout": "Lisää koodi kassalla. Ei voida yhdistää muihin tarjouskoodeihin, kampanjoihin tai alennuksiin.",
	"cancel-icon": "Peruuta",
	"info-icon": "Tarkastele tietoja",
	"check-icon": "Sovellettu",
	"promo-code": "Tarjouskoodi",
	"coupon-callout-popover": "Kuponkikutsu"
}
};

export { fifi as default };
//# sourceMappingURL=src-localization-texts-fi-fi.json.js.map
